import React from 'react';
import { useModalContent } from './useModalContent';
import { useTranslation } from 'utils/translation';
import Button, { ButtonGroup } from '../Button/Button';

export type CreateModalFormFooterOptions = {
  /** i18n key for the primary submit button (default `form.save`). */
  submitKey?: string;
};

/** Footer for modals whose body contains a v2 `Form` submitted via `type="submit"` + `form` attribute. */
export function createModalFormFooter(
  formId: string,
  options?: CreateModalFormFooterOptions,
) {
  const submitKey = options?.submitKey ?? 'form.save';

  function ModalFormFooter({ close }: { close(): void }) {
    const { isBusy } = useModalContent();
    const { t } = useTranslation();

    return (
      <ButtonGroup align="right">
        <Button variant="cancel" onClick={close} disabled={isBusy}>
          {t('form.cancel')}
        </Button>
        <Button isBusy={isBusy} type="submit" form={formId} size="small">
          {t(submitKey)}
        </Button>
      </ButtonGroup>
    );
  }

  return ModalFormFooter;
}
